// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"

export default class LottieJsonController extends AdvancedController {

  static targets = [ 
    // TODO: use or remove
    // "exampleTarget",
  ];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)
    // TODO: use or remove
  }

}
